import React from 'react';
import { useTranslations } from '@lang';
import { GuestDetail } from 'shared-types/Common';
import { GuestSelection } from './GuestSelection';
import { SpaDetailsRow, SpaDetailsCol, SpaGuestName } from './SpaDetails.styles';

type SpaDetailsProps = {
  guestDetails?: Array<GuestDetail> | null;
  selectionGroups?: any;
};

export const SpaDetails: React.FC<SpaDetailsProps> = ({ guestDetails, selectionGroups }) => {
  const { t } = useTranslations();
  return (
    <>
      {guestDetails &&
        guestDetails?.map(({ title, firstName, lastName, extras, selections, id }) => (
          <SpaDetailsRow key={id}>
            <SpaDetailsCol>
              <SpaGuestName>
                {t(`common.${title.toLowerCase() as 'mr' | 'mrs' | 'miss' | 'ms'}`)}
                {` ${firstName} ${lastName}`}
              </SpaGuestName>
              {selections?.length > 0 && (
                <div>
                  {selections.map(({ classes, treatments }) => (
                    <div>
                      <GuestSelection rows={classes} />
                      <GuestSelection rows={treatments} />
                    </div>
                  ))}
                </div>
              )}
              {extras?.length > 0 && <GuestSelection rows={extras} isExtra />}
              {selectionGroups?.map((group) => (
                <GuestSelection
                  rows={group.selections?.filter(
                    (sel) =>
                      sel.guestDetails?.firstName === firstName &&
                      sel.guestDetails?.lastName === lastName &&
                      sel.guestDetails?.title === title
                  )}
                  isExtra={group.isExtras}
                />
              ))}
            </SpaDetailsCol>
          </SpaDetailsRow>
        ))}
    </>
  );
};
